import {
  faEye,
  faPencil,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import {
  Breadcrumb,
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import Datatable from "../widget/table/Datatable";
import { Link } from "react-router-dom";
import {
  createCompanyAdmin,
  deleteCompanyAdmin,
  getAllCompanyAdmin,
  getCompanyAdminById,
  updateCompanyAdmin,
  updateCompanyLogo,
} from "../service/companyManagement";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import eye from "../assets/image/eye.png";
import eye_of from "../assets/image/eye_off.png";
import { updateStatusofUser } from "../service/userManagement";
import ReactLoading from "react-loading";
import moment from "moment";
import { useCompanyAdmin } from "../contexts/companyAdmin";
import { baseUrlForFile } from "../helpers";
import companyLogo from "../assets/image/logo.png";

// const UpdateLogoComponent = ({ row, handleEditCompanyLogo }) => {
//   const uploadImageRef = useRef(null);

//   return (
//     <div className="position-relative">
//       <img
//         style={{ width: "40px", height: "40px" }}
//         src={baseUrlForFile + "/" + row.companyLogoImage}
//         alt=""
//         onError={({ currentTarget }) => {
//           currentTarget.src = companyLogo;
//         }}
//       />
//       <input
//         ref={uploadImageRef}
//         className="d-none"
//         type="file"
//         onChange={(e) => {
//           handleEditCompanyLogo(row.id, e.target.files[0]);
//         }}
//       />
//       <FontAwesomeIcon
//         className="edit-company-logo-icon"
//         onClick={() => {
//           uploadImageRef.current?.click();
//         }}
//         icon={faPencil}
//       />
//     </div>
//   );
// };

const UpdateLogoComponent = ({ row, handleEditCompanyLogo }) => {
  const uploadImageRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

    if (file && allowedTypes.includes(file.type)) {
      handleEditCompanyLogo(row.id, file);
    } else {
      toast.error("Please select a valid image file (PNG, JPG, JPEG)."); // Show error toastr
    }
  };

  return (
    <div className="position-relative">
      <img
        style={{ width: "40px", height: "40px", objectFit: "contain" }}
        src={baseUrlForFile + "/" + row.companyLogoImage}
        alt=""
        onError={({ currentTarget }) => {
          currentTarget.src = companyLogo;
        }}
      />
      <input
        ref={uploadImageRef}
        className="d-none"
        type="file"
        accept="image/png, image/jpeg, image/jpg" // Restrict file types in the file input
        onChange={handleFileChange}
      />
      <FontAwesomeIcon
        className="edit-company-logo-icon"
        onClick={() => {
          uploadImageRef.current?.click();
        }}
        icon={faPencil}
      />
    </div>
  );
};

export default function SuperDashboard() {
  const userInfo = JSON.parse(localStorage.getItem("AUTH_USER"));
  const userRole = userInfo?.userRole;

  const {
    data,
    setData,
    refreshData,
    calculateCounts,
    counts: {
      totalJobs,
      totalPaidSubscriptionPayment,
      totalPendingSubscriptionPayment,
      totalUserLimit,
      totalUserOccupied,
    },
  } = useCompanyAdmin();

  const initialValues = {
    id: null,
    firstName: "",
    lastName: "",
    companyName: "",
    email: "",
    mobile: "",
    password: "",
    subscriptionPayment: "",
    userLimit: "",
    paymentStatus: "",
    lead: "",
    subscriptionDuration: moment(),
    address1: "",
    address2: "",
    province: "",
    city: "",
    postalCode: "",
    country: "",
  };
  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState(initialValues);
  const [Modalshow, setModalshow] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleClose = () => {
    setModalshow(false);
    setFormValues(initialValues);
    setErrors({});
  };
  const handleShow = () => {
    setModalshow(true);
  };
  const [startDate, setStartDate] = useState(new Date());

  const {
    firstName,
    lastName,
    companyName,
    email,
    mobile,
    password,
    subscriptionPayment,
    userLimit,
    paymentStatus,
    lead,
    subscriptionDuration,
    address1,
    address2,
    province,
    city,
    postalCode,
    country,
  } = formValues;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
    }
  };
  const handleDateChange = (date1) => {
    const date = new Date(date1);

    const pad = (num) => num.toString().padStart(2, "0");
    const formattedDate = `${date?.getFullYear()}-${pad(
      date.getMonth() + 1
    )}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
      date.getMinutes()
    )}:${pad(date.getSeconds())}.${date.getMilliseconds()}`;

    console.log(formattedDate, date, "qwertyuiop");

    setStartDate(new Date(formattedDate));

    setFormValues({
      ...formValues,
      subscriptionDuration: formattedDate,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!firstName) {
      newErrors.firstName = "Enter your First name";
    }
    if (!lastName) {
      newErrors.lastName = "Enter your Last name";
    }
    if (!companyName) {
      newErrors.companyName = "Enter Company name";
    }
    if (!email) {
      newErrors.email = "Enter your email";
    }
    if (!mobile) {
      newErrors.mobile = "Enter your phone number";
    }

    if (!formValues.id) {
      if (!password) {
        newErrors.password = "Enter your Password";
      } else if (password.length < 8) {
        newErrors.password = "Password must be at least 8 characters";
      } else if (!/\d/.test(password)) {
        newErrors.password = "Password must contain at least one digit";
      } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        newErrors.password =
          "Password must contain at least one special character";
      }
    }
    if (!subscriptionPayment) {
      newErrors.subscriptionPayment = "Enter your Duration";
    }

    if (!userLimit) {
      newErrors.userLimit = "Enter User Limit";
    }
    if (!paymentStatus) {
      newErrors.paymentStatus = "Please Select Payment Status";
    }
    if (!lead) {
      newErrors.lead = "Enter Lead Source";
    }
    if (!subscriptionDuration) {
      newErrors.subscriptionDuration = "Enter Duration";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateForm();

    if (isValid) {
      setLoader(true);

      try {
        let response = null;
        const obj = {
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          companyName: formValues.companyName,
          email: formValues.email,
          mobile: formValues.mobile,
          subscriptionPayment: formValues.subscriptionPayment,
          userLimit: formValues.userLimit,
          paymentStatus: formValues.paymentStatus === "1" ? true : false,
          lead: formValues.lead,
          subscriptionDuration: formValues.subscriptionDuration,
        };
        if (formValues.password) {
          obj.password = formValues.password;
        }
        if (formValues.address1) obj.address1 = formValues.address1;
        if (formValues.address2) obj.address2 = formValues.address2;
        if (formValues.province) obj.province = formValues.province;
        if (formValues.city) obj.city = formValues.city;
        if (formValues.postalCode) obj.postalCode = formValues.postalCode;
        if (formValues.country) obj.country = formValues.country;

        if (formValues.id) {
          obj.id = formValues.id;

          response = await updateCompanyAdmin(obj);
          toast.success("Company Admin is updated successfully!", {
            autoClose: 3000,
          });
        } else {
          response = await createCompanyAdmin(obj);
          if (!response?.status) {
            toast.error(response?.response?.data?.message);
          } else {
            toast.success("Company Admin is added successfully!");
          }
        }

        if (response) {
          setData((prevData) => [response?.data, ...prevData]);
          await refreshData();
          setFormValues(initialValues);
          handleClose();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        refreshData();
        setTimeout(() => {
          setLoader(false);
        }, 3000);
      }
    }
  };

  const handleEditCompanyLogo = async (id, image) => {
    console.log("formData123");
    try {
      const formData = new FormData();
      formData.append("UserId", id);
      formData.append("CompanyLogoImage", image);
      const { data } = await updateCompanyLogo(formData);
      console.log(id, image, "formData", data);
      toast.success(data.message);
      await refreshData();
    } catch (err) {
      toast.error("Error while updating logo.");
    }
  };

  const columns = [
    {
      name: "Logo",
      selector: (row) => row.companyLogoImage,
      sortable: true,
      cell: (row) => (
        <UpdateLogoComponent
          row={row}
          handleEditCompanyLogo={handleEditCompanyLogo}
        />
      ),
    },
    {
      name: "Company",
      selector: (row) => row.companyName,
      sortable: true,
    },
    {
      name: "User Occupied",
      selector: (row) => row.userOccupied,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Total Jobs",
      selector: (row) => row.jobCount,
      sortable: true,
    },

    {
      name: "Subscription Payment",
      selector: (row) => row.subscriptionPayment,
      sortable: true,
      cell: (row) => {
        const payment = row.subscriptionPayment;
        return `$${payment?.toLocaleString()}`;
      },
    },
    {
      name: "Lead Source",
      selector: (row) => row.lead,
      sortable: true,
    },
    {
      name: "Payment Status",
      selector: (row) => (row.paymentStatus === true ? "Paid" : "Pending"),
      sortable: true,
    },
    {
      name: "User Limit",
      selector: (row) => row.userLimit,
      sortable: true,
    },
    {
      name: "Start Date",

      //selector: (row) => row.subscriptionDuration?.replace("T", "  "),
      selector: (row) =>
        moment(row.subscriptionDuration).utc().format("YYYY-MM-DD h:mm A"),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) =>
        getStatusFromLocalStorage(row.id) ? "Approved" : "Approve",

      cell: (row) => (
        <Button
          variant={
            getStatusFromLocalStorage(row.id)
              ? "outline-success"
              : "outline-danger"
          }
          className="superDashboard"
          onClick={() => handleStatusChange(row)}
        >
          {getStatusFromLocalStorage(row.id) ? "Approved" : "Unapproved"}
        </Button>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="actionBtngroup">
          <Link
            to="/UserManagement"
            state={{ adminID: row?.id, companyName: row.companyName }}
            className="btn custom-btn px-2 py-1 w-auto"
          >
            <FontAwesomeIcon icon={faEye} className="me-1" />
            User
          </Link>
          <Button variant="" onClick={() => handleEdit(row.id)}>
            <FontAwesomeIcon icon={faPencil} />
          </Button>
          <Button variant="" onClick={() => handleDelete(row.id)}>
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
      ),
    },
  ];
  const getStatusFromLocalStorage = (adminId) => {
    return localStorage.getItem(`admin-${adminId}-status`) === "true";
  };

  const handleStatusChange = async (row) => {
    let statuscode = !row.status;
    localStorage.setItem(`admin-${row.id}-status`, statuscode);

    const updatedStatus = await updateStatusofUser(row.id, statuscode);

    if (updatedStatus) {
      setData((prevData) =>
        prevData.map((admin) =>
          admin.id === row.id ? { ...admin, status: statuscode } : admin
        )
      );

      if (updatedStatus.data) {
        toast.success("Company admin approved successfully!", {
          autoClose: 3000,
        });
      } else {
        toast.error("Company admin unapproved successfully!", {
          autoClose: 3000,
        });
      }
    } else {
      toast.error("Failed to update Admin status.", { autoClose: 3000 });
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      setLoader(false);
      try {
        const adminData = await getAllCompanyAdmin();
        adminData?.data.forEach((admin) => {
          localStorage.setItem(`admin-${admin.id}-status`, admin?.isActive);
        });
      } catch (err) {
        setError("Failed to fetch data");
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    };
    fetchUserData();
  }, []);

  // getCompanyAdminById
  const handleEdit = async (id) => {
    try {
      let data = await getCompanyAdminById(id);
      if (data?.status) {
        setFormValues({
          ...formValues,
          id: data.data.id ?? id,
          firstName: data.data.firstName,
          lastName: data.data.lastName,
          companyName: data.data.companyName,
          email: data.data.email,
          mobile: data.data.mobile,
          password: data.data.password,
          subscriptionPayment: data.data.subscriptionPayment,
          userLimit: data.data.userlimit,
          lead: data.data.lead,
          paymentStatus: data.data.paymentStatus === true ? "1" : "0",
          subscriptionDuration: data.data.subscriptionDuration,
          address1: data.data.address1,
          address2: data.data.address2,
          province: data.data.province,
          city: data.data.city,
          postalCode: data.data.postalCode,
          country: data.data.country,
        });
        setModalshow(true);
        setStartDate(new Date(data.data.subscriptionDuration));
      } else {
      }
    } catch (error) {
      console.error("Error occurred while editing:", error);
    }
  };
  // Delete Revenue
  const handleDelete = async (id) => {
    try {
      console.log("Delete clicked for ID:", id);
      const { isConfirmed } = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if (isConfirmed) {
        const response = await deleteCompanyAdmin(id);
        if (response) {
          await refreshData();
          Swal.fire("Deleted!", "Admin deleted successfully!", "success");
        } else {
          Swal.fire("Error!", "Failed to delete Company Admin.", "error");
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  if (loading) {
    return (
      <div className="loading-container custom_loader globe_loader">
        <ReactLoading type={"bars"} color="#33995e" height={60} width={60} />
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <Container fluid className="p-0 my-3 super_dashboard ">
      <div className="d-flex justify-content-between align-items-center ">
        {" "}
        <div>
          <div className="main_title"> Dashboard</div>
          <Breadcrumb className="superAdmin">
            <Breadcrumb.Item
              href="/Dashboard"
              className="CurrentClass"
            ></Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div>
          <Button className="btn custom-btn mb-3 border-0" onClick={handleShow}>
            <FontAwesomeIcon icon={faPlus} /> Add Company
          </Button>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center total-count">
        {" "}
        <div>
          <div className="dashboard-sub-title">
            {" "}
            Total User Limit:{" "}
            <span className="dashboard-sub-title-font">{totalUserLimit}</span>
          </div>
        </div>
        <div>
          <div className="dashboard-sub-title">
            {" "}
            Total User Occupied:{" "}
            <span className="dashboard-sub-title-font">
              {totalUserOccupied}
            </span>
          </div>
        </div>
        <div>
          <div className="dashboard-sub-title">
            {" "}
            Total Jobs:{" "}
            <span className="dashboard-sub-title-font">{totalJobs}</span>
          </div>
        </div>
        <div>
          <div className="dashboard-sub-title">
            {" "}
            Total Paid Payment:{" "}
            <span className="dashboard-sub-title-font">
              ${totalPaidSubscriptionPayment.toLocaleString()}
            </span>
          </div>
        </div>
        <div>
          <div className="dashboard-sub-title-margin-r">
            {" "}
            Total Pending Payment:{" "}
            <span className="dashboard-sub-title-font">
              ${totalPendingSubscriptionPayment.toLocaleString()}
            </span>
          </div>
        </div>
        {/* <div>
          <div className="dashboard-sub-title-margin-r"> Total Subscription Payment: <span className="dashboard-sub-title-font">${totalSubscriptionPayment.toLocaleString()}</span></div>
        </div> */}
      </div>
      <Row>
        <Col md={12}>
          <div className="border-0 p-3 rounded card ">
            <div className="title-container">
              <p>Company List</p>
            </div>
            <Datatable
              columns={columns}
              data={data}
              dateFieldForFilter="subscriptionDuration"
              onTableDataChange={(data) => calculateCounts(data)}
            />
          </div>
        </Col>
      </Row>

      <Modal show={Modalshow} onHide={handleClose} centered size="lg">
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton className="border-0">
            <Modal.Title>
              {" "}
              {formValues.id ? "Update Company" : "Add Company"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="custom_form mb-4 position-relative">
              <h6>Company Info</h6>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      {" "}
                      First Name
                      <span className="require-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      value={firstName}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.firstName ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter First Name"
                    />
                    {errors.firstName && (
                      <Form.Text className="text-danger">
                        Enter your first name
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    {/* <Form.Label style={{color: "red"}} > Last Name *</Form.Label> */}
                    <Form.Label>
                      Last Name
                      <span className="require-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      value={lastName}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.lastName ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Last Name"
                    />
                    {errors.lastName && (
                      <Form.Text className="text-danger">
                        Enter your last name
                        <span className="require-star">*</span>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label> Company Name</Form.Label>
                    <span className="require-star">*</span>
                    <Form.Control
                      type="text"
                      name="companyName"
                      value={companyName}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.companyName ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Company Name"
                    />
                    {errors.companyName && (
                      <Form.Text className="text-danger">
                        Enter your Company name
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Email</Form.Label>
                    <span className="require-star">*</span>
                    <Form.Control
                      type="email"
                      name="email"
                      value={email}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.email ? "border-danger mb-0" : ""
                      }`}
                      placeholder="xyz@info.com"
                    />
                    {errors.email && (
                      <Form.Text className="text-danger">
                        Enter your email
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Mobile
                      <span className="require-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="mobile"
                      value={mobile}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.mobile ? "border-danger mb-0" : ""
                      }`}
                      placeholder="+1 (751) 505-4112"
                      onKeyPress={(e) => {
                        if (!/^\d$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors.mobile && (
                      <Form.Text className="text-danger">
                        {errors.mobile === "Enter your number"
                          ? "Enter your number"
                          : "Phone number must be exactly 10 digits"}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Password
                      {formValues.id ? (
                        " (optional)"
                      ) : (
                        <span className="require-star">*</span>
                      )}
                    </Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={password}
                        onChange={handleChange}
                        className={`ps-3 pe-5 ${
                          errors.password ? "border-danger mb-0" : ""
                        }`}
                        placeholder="Enter a Password"
                      />

                      <img
                        src={showPassword ? eye : eye_of}
                        alt="Toggle Password Visibility"
                        className="position-absolute right_icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    </div>
                    {errors.password && (
                      <Form.Text className="text-danger">
                        {errors.password}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Subscription Payment
                      <span className="require-star">*</span>
                    </Form.Label>

                    <Form.Control
                      type="number"
                      name="subscriptionPayment"
                      value={subscriptionPayment}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.subscriptionPayment ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Subscription Pay"
                    />
                    {errors.subscriptionPayment && (
                      <Form.Text className="text-danger">
                        Enter Duration
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Add User Limit
                      <span className="require-star">*</span>
                    </Form.Label>

                    <Form.Control
                      type="number"
                      name="userLimit"
                      value={userLimit}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.userLimit ? "border-danger mb-0" : ""
                      }`}
                      placeholder="User Limit"
                    />
                    {errors.userLimit && (
                      <Form.Text className="text-danger">
                        Enter User Limit
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Payment Status
                      <span className="require-star">*</span>
                    </Form.Label>

                    <Form.Select
                      name="paymentStatus"
                      value={paymentStatus}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.paymentStatus ? "border-danger mb-0" : ""
                      }`}
                    >
                      <option>--Select payment status--</option>
                      <option value="1">Paid</option>
                      <option value="0">Pending</option>
                    </Form.Select>
                    {errors.paymentStatus && (
                      <Form.Text className="text-danger">
                        Select Payment Status
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Lead Source
                      <span className="require-star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="lead"
                      value={lead}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.lead ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Lead Source"
                    />
                    {errors.lead && (
                      <Form.Text className="text-danger">
                        Enter Lead Source
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Subscription Start Date
                      <span className="require-star">*</span>
                    </Form.Label>

                    <DatePicker
                      selected={startDate}
                      onChange={handleDateChange}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      timeCaption="time"
                      dateFormat="yyyy-MM-dd HH:mm"
                      className="form-control"
                    />
                    <Form.Control
                      type="hidden"
                      name="subscriptionDuration"
                      value={formValues.subscriptionDuration}
                      onChange={handleChange}
                    />
                    {errors.subscriptionDuration && (
                      <Form.Text className="text-danger">
                        Enter Duration
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <div className="custom_form mb-4 position-relative ">
              <h6>Company Address</h6>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Address 1</Form.Label>
                    <Form.Control
                      type="text"
                      name="address1"
                      value={address1}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.address1 ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Address 1"
                    />
                    {errors.address1 && (
                      <Form.Text className="text-danger">
                        Enter your address
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Address 2</Form.Label>
                    <Form.Control
                      type="text"
                      name="address2"
                      value={address2}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.address2 ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Address 2"
                    />
                    {errors.address2 && (
                      <Form.Text className="text-danger">
                        Enter your address2
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>State</Form.Label>
                    <Form.Control
                      type="text"
                      name="province"
                      value={province}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.province ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter State"
                    />
                    {errors.province && (
                      <Form.Text className="text-danger">
                        Enter your State
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      name="city"
                      value={city}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.city ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter City"
                    />
                    {errors.city && (
                      <Form.Text className="text-danger">
                        Enter your city
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Postal Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="postalCode"
                      value={postalCode}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.postalCode ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Postal Code"
                    />
                    {errors.postalCode && (
                      <Form.Text className="text-danger">
                        Enter your postal code
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      type="text"
                      name="country"
                      value={country}
                      onChange={handleChange}
                      className={`px-3 ${
                        errors.country ? "border-danger mb-0" : ""
                      }`}
                      placeholder="Enter Country"
                    />
                    {errors.country && (
                      <Form.Text className="text-danger">
                        Enter your country
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pt-0">
            <Button
              variant="outline-danger"
              className="px-5"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button variant="success" type="submit" className="px-5">
              {formValues.id ? "Update" : "Save"}
            </Button>
          </Modal.Footer>
        </form>
        {loader ? (
          <ReactLoading
            type={"bars"}
            color="#33995e"
            height={60}
            width={60}
            className={"globe_loader"}
          />
        ) : (
          ""
        )}
      </Modal>
      {/* Add Company Modal End*/}
    </Container>
  );
}
